import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Brands from "../pages/brands/page";
import Markets from "../pages/markets/page";
import Digital from "../pages/digital/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/brands",
    element: <Brands />,
  },
  {
    path: "/markets",
    element: <Markets />,
  },
  {
    path: "/digital",
    element: <Digital />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
